export const handleValueChange = (event,prevValues)=> {
    const {name,value}=event.target
    return {
      ...prevValues,
      [name]: value,
    };
  };